<script>
	export let disabled = null;

	export let contactName = null;
	export let directorName = null;
	export let executorName = null;
	export let poaName = null;
	export let solicitorName = null;
	export let optOutType = null;

	const clearNames = () => {
		directorName = null;
		executorName = null;
		poaName = null;
		solicitorName = null;
	};
</script>

<section style="margin-bottom: 20px;">
	<table>
		<colgroup>
			<col style="width: 25%;" />
			<col style="width: 15%;" />
			<col style="width: 25%;" />
			<col style="width: 35%" />
		</colgroup>
		<tbody>
			<tr>
				<td colspan="4" style="font-size: 14px;">
					I, &nbsp;&nbsp;&nbsp;<input
						readonly
						type="text"
						value={contactName}
						class="form-control paper-based"
						style="width: 400px;"
					/>&nbsp;, am
				</td>
			</tr>
			<tr>
				<td colspan="2">
					<div class="custom-control custom-radio">
						<input
							{disabled}
							class="custom-control-input"
							type="radio"
							name="claimant"
							id="claimant-gm"
							value="Group Member"
							bind:group={optOutType}
							on:click={clearNames}
							required
							data-bouncer-target=".declaration-error"
						/>
						<label for="claimant-gm" class="custom-control-label"> a group member </label>
					</div>
				</td>
			</tr>
			<tr>
				<td>
					<div class="custom-control custom-radio">
						<input
							{disabled}
							class="custom-control-input"
							type="radio"
							name="claimant"
							id="claimant-d"
							value="Director"
							bind:group={optOutType}
							on:click={clearNames}
							required
							data-bouncer-target=".declaration-error"
						/>
						<label for="claimant-d" class="custom-control-label"> a director of </label>
					</div>
				</td>
				<td colspan="2">
					<input
						disabled={disabled || optOutType !== "Director"}
						required={optOutType === "Director"}
						type="text"
						placeholder="Company"
						bind:value={directorName}
						class="form-control paper-based"
						style="width: 100%;"
					/>
				</td>
				<td style="font-size: 14px;">which is a group member</td>
			</tr>
			<tr>
				<td colspan="2">
					<div class="custom-control custom-radio">
						<input
							{disabled}
							class="custom-control-input"
							type="radio"
							name="claimant"
							id="claimant-ex"
							value="Executor"
							bind:group={optOutType}
							on:click={clearNames}
							required
							data-bouncer-target=".declaration-error"
						/>
						<label for="claimant-ex" class="custom-control-label"> an Executor for the Estate of </label>
					</div>
				</td>
				<td>
					<input
						disabled={disabled || optOutType !== "Executor"}
						required={optOutType === "Executor"}
						type="text"
						placeholder="Estate"
						bind:value={executorName}
						class="form-control paper-based"
						style="width: 100%;"
					/>
				</td>
				<td style="font-size: 14px;">who is a group member</td>
			</tr>
			<tr>
				<td colspan="2">
					<div class="custom-control custom-radio">
						<input
							{disabled}
							class="custom-control-input"
							type="radio"
							name="claimant"
							id="claimant-poa"
							value="Power of Attorney"
							bind:group={optOutType}
							on:click={clearNames}
							required
							data-bouncer-target=".declaration-error"
						/>
						<label for="claimant-poa" class="custom-control-label"> a power of attorney for </label>
					</div>
				</td>
				<td>
					<input
						disabled={disabled || optOutType !== "Power of Attorney"}
						required={optOutType === "Power of Attorney"}
						type="text"
						placeholder="Name"
						bind:value={poaName}
						class="form-control paper-based"
						style="width: 100%;"
					/>
				</td>
				<td style="font-size: 14px;">who is a group member</td>
			</tr>
			<tr>
				<td colspan="2">
					<div class="custom-control custom-radio">
						<input
							{disabled}
							class="custom-control-input"
							type="radio"
							name="claimant"
							id="claimant-sol"
							value="Solicitor"
							bind:group={optOutType}
							on:click={clearNames}
							required
							data-bouncer-target=".declaration-error"
						/>
						<label for="claimant-sol" class="custom-control-label"> an Executor for the Estate of </label>
					</div>
				</td>
				<td>
					<input
						disabled={disabled || optOutType !== "Solicitor"}
						required={optOutType === "Solicitor"}
						type="text"
						placeholder="Name"
						bind:value={solicitorName}
						class="form-control paper-based"
						style="width: 100%;"
					/>
				</td>
				<td style="font-size: 14px;">who is a group member</td>
			</tr>
			<tr>
				<td colspan="4" class="declaration-error"></td>
			</tr>
			<tr>
				<td colspan="4">
					in the above group proceeding, and give notice under section 33K(2) of the Supreme Court Act 1986
					that I am opting out of this proceeding.
				</td>
			</tr>
		</tbody>
	</table>
</section>

<style>
	input.paper-based {
		display: inline;
	}

	td {
		padding: 8px;
	}

	.custom-control-label {
		height: 35px;
		line-height: 35px;
	}

	.custom-control-label::after {
		top: 9px;
	}

	.custom-radio .custom-control-label::before {
		top: 9px;
	}
	.custom-control-input:checked ~ .custom-control-label::before {
		top: 9px;
	}
</style>
